import {ColoredAvatar} from "./colored-avatar";
import React from "react";

export const AnimalAvatar = ({animal}: { animal: { id: string, name?: string } }) => (
    <ColoredAvatar id={animal.id} name={animal.name}/>
);
